<footer class="px-5 bg-black root-container">
  <div class="py-4 border-t-2 border-gray-50 text-gray-50">
    <div class="flex justify-between w-full">
      <div>
        <h3 class="mb-3 text-semibold">Development Team</h3>
        <div class="dev">
          <div>
            <p>Patrick Ivan Sundiam</p>
            <p>Web Developer</p>
            <p>ivansundiam03&#64;gmail.com</p>
          </div>

          <div>
            <p>Janelle Marie Geco</p>
            <p>Web Designer</p>
            <p>janellegeco&#64;gmail.com</p>
          </div>  
        </div>
      </div>

      <div class="text-end">
        <p class="text-xs">Presented by:</p>
        <div class="flex justify-end space-x-3">
          <img src="/assets/images/sponsors/sponsor_5.png" width="64" alt="sponsor logo" />
          <img src="/assets/images/sponsors/sponsor_4.png" width="80" alt="sponsor logo" />
        </div>
        <p>&copy;2025 Hytec Power Incorporated. All rights reserved.</p>
        <p> All other names/trademarks are the property of their respective owners.</p>
      </div>
    </div>
  </div>
</footer>